import ReportApi from '@/api/ReportApi';
import store from '../store/index'
import router from '../router/index'

export default {
    async createDeviceReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<void> {
        if (!store.getters.loggedIn(Date.now())) {
            router.push('/login');
        }

        await ReportApi.createDeviceReport(recipients, columns, filters, options, cc, bcc, description, fileNote);
    },    
    async createReadingReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        if (!store.getters.loggedIn(Date.now())) {
            router.push('/login');
        }

        await ReportApi.createReadingReport(recipients, columns, filters, options, cc, bcc, description, fileNote);
    },        
    async createPropertyReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        if (!store.getters.loggedIn(Date.now())) {
            router.push('/login');
        }

        await ReportApi.createPropertyReport(recipients, columns, filters, options, cc, bcc, description, fileNote);
    }, 
    async createBillingReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        if (!store.getters.loggedIn(Date.now())) {
            router.push('/login');
        }

        await ReportApi.createBillingReport(recipients, columns, filters, options, cc, bcc, description, fileNote);
    },    
    async createMeteringReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        if (!store.getters.loggedIn(Date.now())) {
            router.push('/login');
        }

        await ReportApi.createMeteringReport(recipients, columns, filters, options, cc, bcc, description, fileNote);
    },
    async createIotDeviceReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        if (!store.getters.loggedIn(Date.now())) {
            router.push('/login');
        }

        await ReportApi.createIotDeviceReport(recipients, columns, filters, options, cc, bcc, description, fileNote);
    },    
    async createConsumptionReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        if (!store.getters.loggedIn(Date.now())) {
            router.push('/login');
        }

        await ReportApi.createConsumptionReport(recipients, columns, filters, options, cc, bcc, description, fileNote);
    },
    async createConsumptionTrendReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        if (!store.getters.loggedIn(Date.now())) {
            router.push('/login');
        }

        await ReportApi.createConsumptionTrendReport(recipients, columns, filters, options, cc, bcc, description, fileNote);
    },
}
  